import React,{useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BookingButton from './BookingButton';

const {FiPlus,FiMinus}=FiIcons;

const FAQSection=()=> {
const [openIndex,setOpenIndex]=useState(null);

const faqs=[ 
{question: "My child won't sit still for therapy. How will this work?",answer: "Perfect! We don't expect them to. We practice in natural,movement-based settings. Therapy happens on the floor,at the table,and in the playground. We follow their motivation to achieve their attention."},
{question: "Will insurance cover this?",answer: "Most insurance plans cover speech-language pathology services for communication and feeding disorders (dysphagia) with a diagnosis. We help you verify your benefits and navigate coverage."},
{question: "Is this a replacement for medical care or other therapies?",answer: "Not at all. We complement your child's medical team. ✓ CONTINUE MEDICAL CARE for health monitoring,developmental pediatrics,and any medical treatments. ✓ ADD OUR SPECIALIZED THERAPY to build the foundations that accelerate all development."},
{question: "My child is only 12 months old—isn't it too early?",answer: "The brain does its most important growing from birth to 5. The most important step is to start as soon as possible¹. Early support prevents bigger challenges later."},
{question: "Why speech therapy for feeding issues?",answer: "The same muscles and reflexes used for eating are used for talking. SLPs are uniquely trained in oral-motor development,swallowing safety,and sensory processing related to feeding."},
{question: "What if my child hasn't been diagnosed with anything?",answer: "You don't need a diagnosis to access early intervention. If you're concerned about development,that's reason enough to start building stronger foundations."},
{question: "How do I know if this is autism vs. late talking vs. something else?",answer: "We help figure that out. We assess and address whatever we find."},
{question: "Why come to you instead of a state-run early intervention program?",answer: "State programs are a wonderful resource. We often work alongside them. The difference is specialization and intensity. We offer direct,1-on-1 therapy with an SLP who is an expert in the most complex cases like feeding disorders and autism,often with less wait time."} 
];

const toggleFAQ=(index)=> {
setOpenIndex(openIndex===index ? null : index);
};

return ( 
<section id="faq" className="py-20 bg-gray-50"> 
<div className="max-w-4xl mx-auto px-6 lg:px-8"> 
<motion.div initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.8}} className="text-center mb-12" > 
<h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 font-serif"> Frequently Asked <span className="text-primary-600">Questions</span> </h2> 
<p className="text-lg text-gray-600 max-w-2xl mx-auto"> Get answers to common questions about early intervention therapy </p> 
</motion.div> 

<div className="space-y-3"> 
{faqs.map((faq,index)=> ( 
<motion.div key={index} initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.5,delay: index * 0.1}} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" > 
<button onClick={()=> toggleFAQ(index)} className="w-full p-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200" > 
<h3 className="font-semibold text-gray-900 pr-4 text-sm"> {faq.question} </h3> 
<div className="flex-shrink-0"> 
<SafeIcon icon={openIndex===index ? FiMinus : FiPlus} className="h-4 w-4 text-primary-600" /> 
</div> 
</button> 
<AnimatePresence> 
{openIndex===index && ( 
<motion.div initial={{height: 0,opacity: 0}} animate={{height: 'auto',opacity: 1}} exit={{height: 0,opacity: 0}} transition={{duration: 0.3}} className="overflow-hidden" > 
<div className="px-4 pb-4"> 
<div className="border-t border-gray-200 pt-3"> 
<p className="text-gray-700 leading-relaxed whitespace-pre-line text-sm"> {faq.answer} </p> 
</div> 
</div> 
</motion.div> 
)} 
</AnimatePresence> 
</motion.div> 
))} 
</div> 

<motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: 0.5}} className="text-center mt-8" > 
<p className="text-gray-600 mb-4 text-sm">Still have questions?</p> 
<div className="flex flex-col sm:flex-row gap-4 justify-center"> 
<BookingButton text="Get Personal Answers" /> 
<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} href="https://www.wethebillions.com/quiz" className="btn-secondary" > 
Take the FREE Quiz 
</motion.a> 
</div> 
</motion.div> 
</div> 
</section> 
);
};

export default FAQSection;